import { InlineEmptyStateOnboarding } from "@octopusdeploy/design-system-components";
export const NoEnvironmentsSelected = () => {
    return <InlineEmptyStateOnboarding illustration={"NoEntities"} title={"Select an environment above to find matching apps"} description={"Octopus can then show matching apps to help you verify them\u00A0before\u00A0deployment."}/>;
};
